/** PURE_IMPORTS_START .._.._Observable,.._.._operator_audit PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { audit } from '../../operator/audit';
Observable.prototype.audit = audit;
//# sourceMappingURL=audit.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/audit.js
// module id = 501
// module chunks = 0